// Calendars
export const REQUEST_CALENDARS_PENDING = 'REQUEST_CALENDARS_PENDING';
export const REQUEST_CALENDARS_SUCCESS = 'REQUEST_CALENDARS_SUCCESS';
export const REQUEST_CALENDARS_FAILED = 'REQUEST_CALENDARS_FAILED';
export const SET_CALENDAR = 'SET_CALENDAR';
export const ADD_CALENDAR = 'ADD_CALENDAR';
export const UPDATE_CALENDAR = 'UPDATE_CALENDAR';
export const DELETE_CALENDAR = 'DELETE_CALENDAR';
export const RECEIVE_CALENDAR = 'RECEIVE_CALENDAR';


// Messages
export const REQUEST_SCHEDULES_PENDING = 'REQUEST_SCHEDULES_PENDING';
export const REQUEST_SCHEDULES_SUCCESS = 'REQUEST_SCHEDULES_SUCCESS';
export const REQUEST_SCHEDULES_FAILED = 'REQUEST_SCHEDULES_FAILED';
export const SET_SCHEDULE = 'SET_SCHEDULE';
export const ADD_SCHEDULE = 'ADD_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const RECEIVE_SCHEDULE = 'RECEIVE_SCHEDULE';
export const SET_SCHEDULE_PENDING = 'SET_SCHEDULE_PENDING';
export const SET_SCHEDULE_SUCCESS = 'SET_SCHEDULE_SUCCESS';
export const SET_SCHEDULE_FAILED = 'SET_SCHEDULE_FAILED';


// User Info
export const SET_USERNAME = 'SET_USERNAME';